<template>
    <div class="consul-deal clearfix">
        <div class="deal-content marginP" >
            <div class="part-right consul-deal-part mypatient">
                <object  id="LODOP_OB" classid="clsid:2105C259-1E0C-4534-8141-A753534CB4CA" width=0 height=0>
                    <embed id="LODOP_EM" type="application/x-print-lodop" width=0 height=0></embed>
                </object>
                <!--startprint1-->
                <div id="print-wrap" class="print-wrap paddingL20">
                    <table border="1px" width="600px" style="margin-left:20%;border-collapse:collapse;font-size: 14px;" align="center">
                        <caption style="padding-top: 50px;padding-bottom: 10px;font-size: 16px;">浙医二院</caption>
                        <caption style="padding-bottom: 10px;">远程医学中心会诊咨询申请表</caption>
                        <tr style="height: 40px;font-size: 12px;">
                            <td width="90px" style="text-align: center">申请医院</td>
                            <td colspan="3" style="text-align: center;">{{ printDetail.consult.acceptDocId?printDetail.consult.acceptHosName:printDetail.consult.hopeHosName}}</td>
                            <td rowspan="5" width="20px" style="text-align: center;">申请类型</td>
                            <td width="50px" colspan="2" style="text-align: left;">
                                <i v-if="printDetail.consult.consultGroupType=='名医会诊'" style="width: 10px;height: 10px;background-color: #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                <i v-else style="width: 10px;height: 10px;border: 1px #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                名医会诊咨询
                            </td>
                        </tr>
                        <tr style="height: 40px;font-size: 12px;">
                            <td style="text-align: center;">患者姓名</td>
                            <td style="text-align: center;width: 100px;">{{ printDetail.consult.consulterName }}</td>
                            <td style="text-align: center;width: 90px;">申请科室</td>
                            <td style="text-align: center;width: 100px;">{{ printDetail.consult.initDeptName }}</td>
                            <td colspan="2" style="text-align: left;">
                                <i v-if="printDetail.consult.consultGroupType=='急会诊'" style="width: 10px;height: 10px;background-color: #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                <i v-else style="width: 10px;height: 10px;border: 1px #000;background-color: #fff;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                急会诊咨询
                            </td>
                        </tr>
                        <tr style="height: 40px;font-size: 12px;">
                            <td style="text-align: center;">性别</td>
                            <td style="text-align: center;">{{ printDetail.consult.consulterGender =="M"?"男":"女" }}</td>
                            <td style="text-align: center;">申请医生</td>
                            <td style="text-align: center;">{{ printDetail.consult.initDocName }}</td>
                            <td colspan="2" style="text-align: left;">
                                <i v-if="printDetail.consult.consultGroupType=='多科会诊'" style="width: 10px;height: 10px;background-color: #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                <i v-else style="width: 10px;height: 10px;border: 1px;background-color: #fff;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                多科会诊咨询
                            </td>
                        </tr>
                        <tr style="height: 40px;font-size: 12px;">
                            <td style="height: 30px;text-align: center;">年龄</td>
                            <td style="text-align: center;">{{ printDetail.consult.consulterAge }}</td>
                            <td style="text-align: center;">联系电话</td>
                            <td style="text-align: center;">{{ printDetail.consult.consulterMobile }}</td>
                            <td colspan="2" style="text-align: left;">
                                <i v-if="printDetail.consult.consultGroupType=='ICU会诊'" style="width: 10px;height: 10px;background-color: #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                <i v-else style="width: 10px;height: 10px;border: 1px;background-color: #fff;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                ICU会诊咨询
                            </td>
                        </tr>
                        <tr style="height: 40px;font-size: 12px;">
                            <td style="height: 30px;text-align: center;">职业</td>
                            <td style="text-align: center;">{{ printDetail.consult.consulterJob?printDetail.consult.consulterJob:'' }}</td>
                            <td style="text-align: center;">申请日期</td>
                            <td style="text-align: center;">{{ formatUnix(printDetail.consult.createTime,'yyyy-MM-dd') }}</td>
                            <td colspan="2" style="text-align: left;">
                                <i v-if="printDetail.consult.consultGroupType=='护理会诊'" style="width: 10px;height: 10px;background-color: #000;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                <i v-else style="width: 10px;height: 10px;border: 1px;background-color: #fff;margin-top: 3px;margin-left: 20px;display: inline-block"></i>
                                护理会诊咨询
                            </td>
                        </tr>
                        <tr style="font-size: 12px;">
                            <td height="200px" style="text-align: center;">简要病史(申<br/>请医生填写)</td>
                            <td colspan="6" align="left">
                                <p style="text-align: left;padding-left: 10px;margin-bottom: 10px;">主诉：{{ printDetail.consult.consultContent }}</p>
                                <p style="text-align: left;padding-left: 10px;">初步诊断：{{ printDetail.consult.beforeDiagnose }}</p>
                            </td>
                        </tr>
                        <tr style="font-size: 12px;">
                            <td style="height: 90px;text-align: center;">申请会诊目的<br/>(或事由)</td>
                            <td colspan="6" style="text-align: left;padding-left: 10px;">{{ printDetail.consult.consultReason }}</td>
                        </tr>
                        <tr style="font-size: 12px;">
                            <td height="250px" style="text-align: center;">会诊咨询意见</td>
                            <td colspan="6" style="text-align: right;vertical-align: bottom;padding-left: 10px;">
                                <div style="margin-right: 20px;margin-bottom: 10px;">
                                    <span>年</span>
                                    <span style="margin-left: 30px;">月</span>
                                    <span style="margin-left: 30px;">日</span>
                                </div>
                            </td>
                        </tr>
                        <tr style="font-size: 12px;">
                            <td height="60px" style="text-align: center;">会诊咨询科别</td>
                            <td style="text-align: center;">{{ printDetail.consult.acceptDocName?printDetail.consult.acceptDeptName:printDetail.consult.hopeDeptName}}</td>
                            <td style="text-align: center;">专家签名</td>
                            <td>&nbsp;</td>
                            <td colspan="2" style="text-align: center;">职 称</td>
                            <td>&nbsp;</td>
                        </tr>
                    </table>
                    <p style="width: 600px;margin: 5px auto;"><span style="font-size: 12px;padding-left: 5px;">注：会诊中心咨询预约电话：0571-87767099,13486353771</span></p>
                </div>
                <!--endprint1-->
                <div class="blue-btn-wrap no-print" style="width: 600px;margin: 0 auto">
                    <el-button type="primary" class="blue-btn marginB10" @click="print(1)">打印</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>
<script>
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import { MessageBox } from "element-ui";
    import { PRINT_SRC_URL } from "../../data/Url";
    export default{
        data: function(){
            return {}
        },
        components: {},
        computed: {
            printDetail: function(){
                return this.$store.state.printDetail;
            }
        },
        methods: {
            formatUnix: function(time, type="yyyy-MM-dd HH:mm"){//将unix时间戳转换未yyyy-MM-dd HH:mm
        	     return formatUnixTime(time, type);
        	},
            // print: function(){// 打印

        }
    }
</script>